import React from "react";
import { useSiteData } from "../../context/SiteDataContext";
import { Copy, Check } from "lucide-react";

const TokenomicsSection = () => {
  const { tokenomics, siteConfig } = useSiteData();
  const [copied, setCopied] = React.useState(false);
  const logoUrl = siteConfig?.logoUrl || "/marsu.png";

  const contractAddress = tokenomics?.contractAddress || "0xTBA...MARSUPILAMI";
  const totalSupply = tokenomics?.totalSupply || 500000000;
  const distribution = tokenomics?.distribution || [];

  const handleCopy = () => {
    navigator.clipboard.writeText(contractAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const gradientStops = distribution.reduce(
    (acc, item) => {
      const start = acc.total;
      const end = start + item.percentage;
      acc.stops.push(`${item.color} ${start}% ${end}%`);
      acc.total = end;
      return acc;
    },
    { stops: [], total: 0 }
  );

  return (
    <section id="tokenomics" className="relative py-20 overflow-hidden">
      <div className="absolute inset-0 bg-[#060d06]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-center mb-4">
          <span className="text-yellow-400">MARSUPILAMI</span>
          <span className="text-white">NOMICS</span>
        </h2>
        <div className="flex justify-center mb-12">
          <button onClick={handleCopy} className="flex items-center gap-2 bg-[#0d1a0d] border border-[#1a3a1a] rounded-lg px-4 py-2 text-gray-400 hover:text-yellow-400 hover:border-yellow-400/30 transition-all duration-300 text-sm">
            <span className="font-mono text-xs sm:text-sm truncate max-w-[250px] sm:max-w-none">{contractAddress}</span>
            {copied ? <Check size={16} className="text-green-400 flex-shrink-0" /> : <Copy size={16} className="flex-shrink-0" />}
          </button>
        </div>
        <div className="text-center mb-12">
          <p className="text-gray-400 text-sm uppercase tracking-wider mb-2">Total Supply:</p>
          <p className="text-white text-4xl sm:text-5xl font-extrabold">{Number(totalSupply).toLocaleString()}</p>
        </div>
        <div className="flex flex-col lg:flex-row items-center justify-center gap-12">
          <div className="relative">
            <div className="w-64 h-64 sm:w-72 sm:h-72 rounded-full shadow-2xl shadow-yellow-400/10" style={{ background: `conic-gradient(${gradientStops.stops.join(", ")})` }} />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-full bg-[#060d06] border-4 border-[#1a3a1a] flex items-center justify-center shadow-inner">
                <img src={logoUrl} alt="MRS" className="w-20 h-20 sm:w-24 sm:h-24 rounded-full object-contain" />
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-4">
            {distribution.map((item) => (
              <div key={item.name} className="flex items-center gap-4">
                <div className="w-5 h-5 rounded-sm flex-shrink-0" style={{ backgroundColor: item.color }} />
                <span className="text-white font-medium text-base min-w-[160px]">{item.name}</span>
                <span className="text-yellow-400 font-bold text-lg">{item.percentage}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TokenomicsSection;
